export const production = {
  NEXT_PUBLIC_API_URL: 'https://agendapro.com/api_views/workflow/v2',
  NEXT_PUBLIC_APRO_BASE_URL: 'https://app.agendapro.com',
  NEXT_PUBLIC_AP_API_URL: 'https://ap-api.agendapro.com',
  NEXT_PUBLIC_BACK_BASE_URL: 'https://agendapro.com',
  NEXT_PUBLIC_BUSINESS_PROJECT_URL: 'https://business.agendapro.com',
  NEXT_PUBLIC_COOKIE_DOMAIN: 'agendapro.com',
  NEXT_PUBLIC_CYPRESS_BASE_URL: 'https://testere2e.site.agendapro-devpod2.com/cl',
  NEXT_PUBLIC_DEEP_LINKS_URL: 'https://marketplace.agendapro.com',
  NEXT_PUBLIC_DLOCAL_SMART_FIELD_URL: '',
  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: 'clientes-agendapro.firebaseapp.com',
  NEXT_PUBLIC_FIREBASE_PROJECT_ID: 'clientes-agendapro',
  NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: 'clientes-agendapro.appspot.com',
  NEXT_PUBLIC_FRONTEND_COOKIE: 'ap_authorization',
  NEXT_PUBLIC_HOTJAR_VERSION: 6,
  NEXT_PUBLIC_GROWTHBOOK_API_HOST: 'https://growthbook-api.agendaprops.com',
  NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY: 'sdk-hD3RRMV9z1r0VxHf',
  NEXT_PUBLIC_SUCCESS_APP_MESSAGE_CLICK_URL: 'https://market.agendapro.com/app-ec-bookersuccess-booking',
  SLS_ENVIRONMENT: 'production',
};
